// 这个必须在最前面
import {isProd} from "src/utils/envUtil";
import qs from "qs";


class AiPluginUtil {
    static baseUrl = isProd ? 'https://www.5gscw.cn/ai/mobile' : 'http://localhost:3003';

    static push(url){
        window.location.href = url;
    }

    static open(url){
        window.open(url, "_blank");
    }

    static toAiText({aiConfig}) {
        const url = `${AiPluginUtil.baseUrl}/ai-text/?${qs.stringify({
            ...aiConfig,
            isAiShop:true
        })}`;
        this.push(url);
    }

    static toAiScenario({aiConfig}) {
        const url = `${AiPluginUtil.baseUrl}/ai-scenario/?${qs.stringify({
            ...aiConfig,
            isAiShop:true
        })}`;
        this.push(url);
    }

    static toAiCreation({aiConfig}) {
        const url = `${AiPluginUtil.baseUrl}/ai-creation/?${qs.stringify({
            ...aiConfig,
            isAiShop:true
        })}`;
        this.push(url);
    }

    static toAiImage({aiConfig}) {
        const url = `${AiPluginUtil.baseUrl}/ai-image/?${qs.stringify({
            ...aiConfig,
            isAiShop:true
        })}`;
        this.push(url);
    }

    static toAiVideo({aiConfig}) {
        const url = `${AiPluginUtil.baseUrl}/ai-video/?${qs.stringify({
            ...aiConfig,
            isAiShop:true
        })}`;
        this.push(url);
    }
}

export default AiPluginUtil